import DealsSection from "./UI/DealsSection";

export default DealsSection;